<template>
  <div class="mystery-chest">
    <div v-show="isRevealed" id="chest-opened">
      <v-img
        :src="imageAux || require('@/assets/box/box-opened.png')"
        width="18.75rem"
        height="18.75rem"
        contain
      />
    </div>

    <div
      v-show="!isRevealed"
      id="chest-closed"
      class="pointer"
      :class="{
        'animate__animated animate__rubberBand': shouldStretch,
        'float-box': !opened && !shouldStretch,
        'shake-box': opened && !shouldStretch,
      }"
      @click="handleOpen()"
    >
      <v-img
        :src="image || require('@/assets/box/mystery-box.png')"
        width="18.75rem"
        height="18.75rem"
        contain
      />
    </div>
  </div>
</template>

<script>
import "animate.css";

export default {
  name: "MysteryBox",

  props: {
    box: {
      type: Object,
      default: () => {},
    },

    loading: {
      type: Boolean,
      default: false,
    },

    image: {
      type: String,
      default: "",
    },

    imageAux: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      opened: false,
      isRevealed: false,
      shouldStretch: false,
    };
  },

  methods: {
    handleOpen() {
      if (this.opened) return;

      this.$emit("started");
      this.opened = true;
    },

    handleReveal() {
      this.shouldStretch = true;
      this.triggerFlash();

      setTimeout(() => {
        this.shouldStretch = false;
      }, 600);
    },

    triggerFlash() {
      const chestClosed = this.$el.querySelector("#chest-closed .v-image");

      if (!chestClosed) return;

      chestClosed.classList.add("flash-bright");

      setTimeout(() => {
        chestClosed.classList.remove("flash-bright");

        this.isRevealed = true;
        this.$emit("revealed");

        this.triggerFlashOut();
      }, 600);
    },

    triggerFlashOut() {
      const chestOpened = this.$el.querySelector("#chest-opened .v-image");

      if (!chestOpened) return;

      chestOpened.classList.add("flash-bright-out");

      setTimeout(() => {
        chestOpened.classList.remove("flash-bright-out");
      }, 800);
    },

    resetBox() {
      this.opened = false;
      this.isRevealed = false;
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
